import { useState } from 'react';
import { MButton, MRadio } from '@Components/Base';
import { OptionExtended } from '@Components/types/options';
import { Counter } from '@Components/Base/Counter';
import classNames from 'classnames';

import styles from './drawer-items.module.css';

interface DrawerItemsProps {
  selectedRequest: string;
  items: OptionExtended[];
  showCounter?: boolean;
  mobileView?: boolean;
  name?: string;
  onClick?: (label: string, value: string | null) => void;
}

const DrawerItems: React.FC<DrawerItemsProps> = ({
  items,
  onClick,
  selectedRequest,
  showCounter = false,
  mobileView = false,
  name = 'requestType',
}) => {
  const [label, setLabel] = useState<string | null>(null);
  const [value, setValue] = useState<string | null>(null);

  const currentLabel = label || selectedRequest;

  const handleClick = (itemLabel: string, itemValue: string): void => {
    setLabel(itemLabel);
    setValue(itemValue);
  };

  const clearStates = (): void => {
    setLabel(null);
    setValue(null);
  };

  return (
    <div className={styles.drawerItems}>
      <div className={styles.drawerRadioWrapper}>
        <div className={styles.drawerRadioItems}>
          {items?.map((item) => {
            return (
              <div key={item.label} className={styles.drawerRadioItem}>
                {!mobileView ? (
                  <MRadio
                    id={item.label}
                    onChange={() => {
                      setLabel(item.label);
                      setValue(item.value);
                    }}
                    name={name}
                    value={item.label}
                    className={currentLabel === item.label ? 'active' : ''}
                    key={item.label}
                    labelText={item.label}
                    checked={currentLabel === item.label}
                  />
                ) : (
                  <div
                    className={classNames(
                      styles.requestMobileItem,
                      currentLabel === item.label ? 'active' : ''
                    )}
                    key={item.label}
                    onClick={() => handleClick(item.label, item.value)}
                  >
                    <span className={styles.mobileItemLabel}>{item.label}</span>
                  </div>
                )}
                {showCounter && Number.isFinite(item.description) ? (
                  <Counter
                    className={styles.counter}
                    value={item.description}
                  />
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.drawerFooter}>
        <MButton
          className={styles.drawerSelectButton}
          type="primary"
          onClick={() => {
            onClick?.(currentLabel, value);
            clearStates();
          }}
        >
          Select
        </MButton>
      </div>
    </div>
  );
};

export default DrawerItems;
